import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import {TextField} from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import React from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Link from "@material-ui/core/Link";

class OrganizationStep extends React.Component {
    
    render() {
        const {classes} = this.props;
        return (
            <Formik
                enableReinitialize={true}
                initialValues={this.props.initialValue}
                validationSchema={Yup.object({
                    organizationNr: Yup.string()
                        .required('Påkrevd'),
                    name: Yup.string()
                        .max(256, 'Må være mindre eller lik 256 karakterer.')
                        .required('Påkrevd'),
                    telephone: Yup.string()
                        .max(256, 'Må være mindre eller lik 256 karakterer.')
                        .required('Påkrevd'),
                    streetAddress: Yup.string()
                        .max(256, 'Må være mindre eller lik 256 karakterer.')
                        .required('Påkrevd'),
                    zipCode: Yup.string()
                        .max(256, 'Må være mindre eller lik 256 karakterer.')
                        .required('Påkrevd'),
                    city: Yup.string()
                        .max(256, 'Må være mindre eller lik 256 karakterer.')
                        .required('Påkrevd'),
                })}
                
                onSubmit={(values, {setSubmitting}) => {
                    setSubmitting(false);
                    this.props.organizationStepComplete(values);
                }}>
                <Form>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <Field
                            component={TextField}
                            name="organizationNr"
                            label="Organisasjonsnummer"
                            variant="outlined"
                        />
                    </FormControl>

                    <FormControl className={classes.formControl} fullWidth={true}>
                        <Field
                            name="name"
                            label="Firmanavn"
                            variant="outlined"
                            component={TextField}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl} fullWidth={true}>
                        <Field
                            name="telephone"
                            label="Telefon"
                            component={TextField}
                            variant="outlined"
                        />
                    </FormControl>

                    <FormControl className={classes.formControl} fullWidth={true}>
                        <Field
                            name="streetAddress"
                            label="Adresse"
                            component={TextField}
                            variant="outlined"
                        />
                    </FormControl>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <Field
                                    name="zipCode"
                                    label="Post.Nr"
                                    component={TextField}
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={9}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <Field
                                    name="city"
                                    label="By"
                                    component={TextField}
                                    variant="outlined"
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    {this.props.wizardActions}
                </Form>
            </Formik>
        );
    }
}

export default OrganizationStep;